import { View } from 'react-native';
import { useRoute } from '@react-navigation/native';
import { Divider } from '@ui-kitten/components';

import ReservationCancellationPolicy from '../../Components/ReservationCancellationPolicy';
import ListItemLoader from '../../Components/ListItemLoader';
import { RectangleLoader } from '../../Components/Loader';
import {
  ids as reservationStyleIds,
  styles as reservationStyles,
} from '../../Components/Reservation/styles';
import ResponsiveLayout from '../../Components/ScreenWrapper/ResponsiveLayout';
import constants from '../../Config/constants';
import routeList from '../../Routes/list';
import themeStyle from '../../Theme/styles';
import {
  ids as platformStyleIds,
  styles as platformStyles,
} from '../../Theme/styles/platform';

import MapAndInfoLoader from '../ReservationStoreDetails/components/MapAndInfoLoader';

import OverviewAndPartySizeLoader from './components/OverviewAndPartySizeLoader';
import OverviewLoader from './components/OverviewLoader';
import StoreAndTagsLoader from './components/StoreAndTagsLoader';

const PageLoader = () => {
  const route = useRoute();
  const isPreview = route?.name === routeList.RES_EVENT_DETAILS_PREVIEW;
  return (
    <ResponsiveLayout
      LeftComponent={
        <View style={themeStyle.flex1}>
          {/* Web Store Name And Tags */}
          <View
            dataSet={{ media: platformStyleIds.webOnly }}
            style={[platformStyles.webOnly, themeStyle.spacingBottom]}
          >
            <StoreAndTagsLoader />
          </View>
          {/* Event Banner */}
          <View
            style={constants.isWeb && { borderRadius: 20, overflow: 'hidden' }}
          >
            <RectangleLoader height={constants.isWeb ? 250 : 230} />
          </View>
          <View style={reservationStyles.contentContainer}>
            <View
              style={[
                themeStyle.alignItemsStart,
                themeStyle.spacingBottomMedium,
              ]}
            >
              <RectangleLoader width={60} height={32.5} />
            </View>
            {/* Event Name */}
            <View style={themeStyle.spacingBottomSmall}>
              <RectangleLoader height={54} />
            </View>
            {/* Mobile Store Name And Tags */}
            <StoreAndTagsLoader
              dataSet={{ media: platformStyleIds.mobileAndTabletOnly }}
              style={platformStyles.mobileAndTabletOnly}
            />
            <View
              dataSet={{ media: platformStyleIds.mobileAndTabletOnly }}
              style={platformStyles.mobileAndTabletOnly}
            >
              <View style={themeStyle.spacingTopMedium}>
                <OverviewLoader />
              </View>
              <Divider
                dataSet={{ media: reservationStyleIds.sectionDivider }}
                style={[
                  themeStyle.spacingTopMedium,
                  themeStyle.spacingBottom,
                  themeStyle.divider,
                  reservationStyles.sectionDivider,
                ]}
              />
            </View>
            {/* Description */}
            <View style={themeStyle.spacingBottom}>
              <RectangleLoader height={120} />
            </View>
            {/* Dress Code */}
            <RectangleLoader width={150} height={32.5} />
            <View style={[{ width: '30%' }, themeStyle.spacingTopSmall]}>
              <ListItemLoader
                contentContainerStyle={themeStyle.spacingBottom}
                withLeftIcon
              />
            </View>
            {/* Cancellation Policy */}
            <ReservationCancellationPolicy isLoading />
            <Divider
              dataSet={{ media: reservationStyleIds.sectionDivider }}
              style={[
                themeStyle.sectionSeparator,
                reservationStyles.sectionDivider,
              ]}
            />
            <MapAndInfoLoader />
          </View>
          {/* Bottom spacer for mobile */}
          <View
            dataSet={{ media: platformStyleIds.mobileOnly }}
            style={[platformStyles.mobileOnly, themeStyle.pageBottomSpacer]}
          />
        </View>
      }
      RightComponent={<OverviewAndPartySizeLoader />}
      MobileBottomComponent={<OverviewAndPartySizeLoader />}
      backgroundColor={null} // to remove safearea on the top
      rightComponentWidth={285}
      withFooter={!isPreview}
      stickyMobile
    />
  );
};

export default PageLoader;
